<template lang="pug">
div.container
  img(src="../assets/img/smartphone.png")

  p.title つかいかた
  p.first-message
    | オカダヤ商品についているバーコードを、
    | カメラで撮影すると、該当商品の
    | 素材や組成情報を表示します。
  p.second-message
    | ♡タップで、チェックした商品を保存できます。
    | 保存結果は「♡チェックした商品をみる」ボタンから、ご確認いただけます。

  button(@click="$router.push('/redirect')") つかってみる

  p.remarks ・推奨環境：iOS 8.0以上、Android 7.0以上
</template>

<script>
export default {
  mounted() {
    localStorage.setItem("firstVisit", false);
  }
};
</script>

<style lang="sass" scoped>
.container
  display: flex
  flex-direction: column
  padding: 0 13.9vw

img
  align-self: center
  margin: 6vh 1.8vh 0px
  height: 14vh

.title
  margin-top: 5vh
  margin-bottom: 0px
  font-weight: bold
  font-size: 2.2vmax

.first-message
  margin-bottom: 0

button
  align-self: center
  margin-top: 1.2vh

.remarks
  margin-top: 4.2vh
  font-size: 1.5vmax
</style>
